import { createClient } from '@supabase/supabase-js'
import { useApi } from '@/composables/useApi'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Create a single instance
let supabaseInstance = null;

export const getSupabase = () => {
  if (!supabaseInstance) {
    if (!supabaseUrl || !supabaseAnonKey) {
      throw new Error('Missing Supabase environment variables')
    }
    
    supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      realtime: {
        params: {
          eventsPerSecond: 10
        }
      },
      auth: {
        persistSession: true,
        storageKey: 'supabase.auth.token',
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce'
      }
    })
  }
  return supabaseInstance
}

// Export the singleton instance
export const supabase = getSupabase();

// REMOVED: Migration helper functions - all users migrated to Supabase

// Helper function to handle realtime subscription errors
export const handleRealtimeError = (error) => {
  console.error('Realtime subscription error:', error)
  // You can add additional error handling logic here
} 